import { defineComponent, h, computed } from 'vue';
import { makeDownloadQrCodeButton } from '@/ui/components/button/DownloadQrCodeButton';
import { t } from '@/ui/i18n/i18n';

interface QrCodeProps {
  checklistId: number | null;
}

export const QrCode = defineComponent<QrCodeProps>({
  name: 'QrCode',
  props: ['checklistId'],
  setup(props) {
    const creatingMode = computed(() => !props.checklistId);

    return function render() {
      return h('div', [
        h('p', { class: 'checklist-builder__second-stage-title' }, t('checklist.builder.settings.qrcode-title')),
        h('div', {
          class: 'checklist-builder__second-stage-description'
        }, creatingMode.value
          ? t('checklist.builder.settings.qrcode-description-create')
          : t('checklist.builder.settings.qrcode-description-edit')),
        makeDownloadQrCodeButton({
          buttonText: t('checklist.builder.settings.qrcode-button-text'),
          buttonDisabled: creatingMode.value,
          qrCodeData: `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_REDIRECT_ROUTE}?url=${process.env.VUE_APP_DEEP_LINK_FORM_TEMPLATE}/${props.checklistId}`
        }),
      ]);
    };
  },
});
